<template>
  <div>
    <component-header
      title="Apply Promo"
      :hasCreate="true"
      :hasback="false"
      :hasSearch="true"
      :hasReload="false"
      @create-press="$router.push({ name: 'promo-create' })"
    />
    <b-card border-variant="info">
      <b-table
        style="border-radius: 12px"
        responsive
        striped
        hover
        :fields="title"
        :striped="true"
        :bordered="true"
        thead-class="header"
        :items="items"
      >
        <template slot="action" slot-scope="data">
          <b-button size="sm" class="mr-2 button-circle" variant="primary">
            <i class="fa fa-eye"></i>
          </b-button>
        </template> </b-table
    ></b-card>
  </div>
</template>

<script>
import ComponentHeader from "@/components/componentNewHeader";
export default {
  components: {
    ComponentHeader,
  },
  data() {
    return {
      title: [
        {
          key: "date",
          label: "Date",
        },
        {
          key: "type",
          label: "Implacted Customer",
        },
        {
          key: "amount",
          label: "Amount",
        },
        {
          key: "description",
          label: "Prototype",
        },
        {
          key: "status",
          label: "Status",
        },
        {
          key: "action",
        },
      ],
      items: [
        {
          date: "09 / 06 / 2022",
          type: "23",
          description: "AkshayPatra",
          status: "Pending",
          amount: "5400",
        },
      ],
    };
  },
};
</script>
